import Immutable from 'immutable';
import {
  FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS,
  CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS,
} from './actions';
import {
  WASABI_FETCH_USER_SUBSCRIPTIONS_SUCCESS,
  WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_SUCCESS,
} from '../Wasabi/actions';

const initialState = Immutable.fromJS({
  byUser: {
    /*
    userId: {
      plans: {},
      hasLoaded: false,
    }
    */
  },
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function UserSubscriptionPlans(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS:
    case WASABI_FETCH_USER_SUBSCRIPTIONS_SUCCESS: {
      const { userId } = action;
      const subscriptionPlans = Immutable.fromJS(action.subscriptionPlans);
      let newState = state;
      subscriptionPlans.forEach((subscriptionPlan) => {
        newState = newState.setIn(
          [
            'byUser',
            subscriptionPlan.get('userId'),
            'plans',
            subscriptionPlan.get('id'),
          ],
          subscriptionPlan
        );
      });
      newState = newState.setIn(['byUser', userId, 'hasLoaded'], true);
      return newState;
    }
    case CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS:
    case WASABI_UPDATE_USER_SUBSCRIPTION_PLAN_EXPIRY_SUCCESS: {
      const userSubscriptionPlan = Immutable.fromJS(
        action.userSubscriptionPlan
      );
      return state.setIn(
        [
          'byUser',
          userSubscriptionPlan.get('userId'),
          'plans',
          userSubscriptionPlan.get('id'),
        ],
        userSubscriptionPlan
      );
    }
    default: {
      return state;
    }
  }
}
